import BoardList from "../../templates/BoardList";

const Play = () => {
  return <BoardList boardCategory="play" />;
};

export default Play;
